import { getStore, getState } from "../../../store/configureStore";
import * as security from "../../../actions/securityActions";

export default class AangemeldPageHelper {
    constructor(context, redirector) {
        this.context = context;
        this.redirector = redirector;
    }

    init() {
        const keuze = this.context.props.match.params.keuze;

        getStore().dispatch(security.loadAuthorizationInfo()).then(() => {
            this.routeByRoles(getState()?.security, keuze);
        });
    }

    routeByRoles(securityState, keuze) {
        if (!securityState?.roles) {
            this.redirector.goTo('/noAccess');
            return;
        }

        const { isOrganisator, isBeoordelingGemeente, isBeoordelingFedOrKoepel } = securityState.roles;

        if (keuze === "registratie" && isOrganisator) {
            this.redirector.goTo(securityState.showOrbMigratiePage ? "/e-loket/orbmigratie" : "/e-loket/organisatoroverzicht");
        } else if (keuze === "beoordeling" && isBeoordelingGemeente) {
            this.redirector.goTo("/e-loket/gemeente/veldtoertochten");
        } else if (keuze === "beoordeling" && isBeoordelingFedOrKoepel) {
            this.redirector.goTo("/e-loket/federatieOverzicht");
        } else {
            this.redirector.goTo('/noAccess');
        }
    }
}
